import { updateMapPosition } from '../../redux/action/map'
import { logger } from '../../logger/logger'

export const processRegistrationMessageThunk = (message) => (dispatch) => {
  switch (message?.type) {
    case 'registration.DRIVER_GEO_UPDATED_EVENT':
      dispatch(updateMapPosition(message.data))
      break
    default:
			logger.error('Unknown registration message type: ', JSON.stringify(message))
      break
  }
}
